import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUsageAudioV2Response } from './get-usage-audio-v2-response';
import { getUsageAudioV2ResponseSchema } from './get-usage-audio-v2-response';

export async function getUsageAudioV2Api(
  slug: string,
): Promise<IValidatedResponse<IGetUsageAudioV2Response>> {
  return getRequest<IGetUsageAudioV2Response>({
    path: `/challenges/${slug}/audio/v2/usage`,
    schema: getUsageAudioV2ResponseSchema,
  });
}
